import { AxiosRequestConfig } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';

import CasinoSlider from 'Api/Models/CasinoSlider';
import CasinoSliderItem from 'Api/Models/CasinoSliderItem';

class CasinoSlidersApi extends AbstractCRMApi {
    private slidersEndpoint = 'casino_sliders';
    private itemsEndpoint = 'casino_slider_items';

    private multipartConfig = {
        headers: { Accept: 'application/json', 'Content-Type': 'multipart/form-data' },
    };

    public async getAllSliders(page: number = 1, config?: AxiosRequestConfig): Promise<CasinoSlider[]> {
        const { data } = await this.get(`${this.slidersEndpoint}`, {
            ...config,
            params: { ...config?.params, page },
        });

        return data.map((slider: object) => CasinoSlidersApi.mapDataToModel(slider, CasinoSlider));
    }

    public async getItemsBySliderId(sliderId: number): Promise<CasinoSliderItem[]> {
        const { data } = await this.get(`${this.slidersEndpoint}/${sliderId}`);

        return data.map((item: object) => CasinoSlidersApi.mapDataToModel(item, CasinoSliderItem));
    }

    public async getItemById(itemId: number): Promise<CasinoSliderItem> {
        return CasinoSlidersApi.mapDataToModel(
            (await this.get(`${this.itemsEndpoint}/${itemId}`)).data,
            CasinoSliderItem
        );
    }

    public async updateItem(itemId: number, casinoSliderItem: FormData): Promise<CasinoSliderItem> {
        casinoSliderItem.append('_method', 'patch');
        const response = await this.post(`${this.itemsEndpoint}/${itemId}`, casinoSliderItem, this.multipartConfig);

        return CasinoSlidersApi.mapDataToModel(response.data, CasinoSliderItem);
    }

    public async storeItem(sliderItem: FormData): Promise<CasinoSliderItem> {
        const response = await this.post(this.itemsEndpoint, sliderItem, this.multipartConfig);

        return CasinoSlidersApi.mapDataToModel(response.data, CasinoSliderItem);
    }
}

export default new CasinoSlidersApi();
